import React from 'react';
import './Info.css';

export default function Info() {
  return (
    <div className="info-container">
      <div className="info-item">BRUXELLES / PARIS</div>
      <a
        className="info-item info-link"
        href="https://instagram.com/oblikagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        @OBLIKAGRAM
      </a>
      <a
        className="info-item info-link"
        href="mailto:hello@oblik.be"
      >
        HELLO@OBLIK.BE
      </a>
    </div>
  );
}